import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Page, SidebarPanelItem, Stack } from "@skailer-com/uikit";

export const SidebarAccountSettings = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <>
      <Stack direction={"horizontal"} items={"center"} justify={"between"} className={"pr-6"}>
        <Page.Header title={t("core:settings_personal_account_title")} />
      </Stack>

      <Stack className={"px-4"} gap={"sm"}>
        <SidebarPanelItem
          to={"/account-settings"}
          title={t("common:overview")}
          isActive={pathname == "/account-settings"}
        />
        <SidebarPanelItem
          to={"/account-settings/security"}
          title={t("common:security")}
          isActive={pathname == "/account-settings/security"}
        />
        <SidebarPanelItem
          to={"/account-settings/localisation"}
          title={t("core:account_localisation")}
          isActive={pathname == "/account-settings/localisation"}
        />
        <SidebarPanelItem
          to={"/account-settings/theme"}
          title={t("common:theme")}
          isActive={pathname == "/account-settings/theme"}
        />
        <SidebarPanelItem
          to={"/account-settings/notifications"}
          title={t("common:notifications")}
          isActive={pathname == "/account-settings/notifications"}
        />
        <SidebarPanelItem
          to={"/account-settings/integrations"}
          title={t("core:settings_recruitment")}
          isActive={pathname == "/account-settings/integrations"}
        />
      </Stack>
    </>
  );
};
